import { Panel } from "primereact/panel";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function PessoaAssistenteSocial({
    pessoaAssistenteSocial
}: {
    pessoaAssistenteSocial: any
}) {

    if (!pessoaAssistenteSocial || !pessoaAssistenteSocial.FamilySocialAssistance) {
        if (pessoaAssistenteSocial?.message) {
            return <Panel header="Assistência Social"><p>{pessoaAssistenteSocial.message}</p></Panel>;
        }
        return null;
    }

    const data = pessoaAssistenteSocial.FamilySocialAssistance;

    const formatCurrency = (value: number) => {
        if (!value && value !== 0) return 'R$ 0,00';
        return `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const formatDate = (dateString: string) => {
        if (!dateString) return 'Não Informado';
        try {
            if (dateString.length >= 10) {
                return `${dateString.substring(8, 10)}/${dateString.substring(5, 7)}/${dateString.substring(0, 4)}`;
            }
            return dateString;
        } catch (e) {
            return dateString;
        }
    };





    return (
        <Panel header="Assistência Social">
            <div>
                <div className="flex-consulta flex-wrap gap-3">
                    <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
                        <div className="flex-consulta justify-content-between gap-5">
                            <div className="flex-consulta flex-column gap-1">
                                <span style={{ color: 'white' }} className="text-sm">Benefícios</span>
                                <span style={{ color: 'white' }} className="font-bold text-lg">{data.TotalBeneficiaries || 0}</span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                                <i className="pi pi-gift" />
                            </span>
                        </div>
                    </Card>

                    <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
                        <div className="flex-consulta justify-content-between gap-5">
                            <div className="flex-consulta flex-column gap-1">
                                <span style={{ color: 'white' }} className="text-sm">Benefícios Ativos</span>
                                <span style={{ color: 'white' }} className="font-bold text-lg">{data.TotalActiveAssistances || 0}</span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                                <i className="pi pi-gift" />
                            </span>
                        </div>
                    </Card>

                    <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
                        <div className="flex-consulta justify-content-between gap-5">
                            <div className="flex-consulta flex-column gap-1">
                                <span style={{ color: 'white' }} className="text-sm">Total Parcelas</span>
                                <span style={{ color: 'white' }} className="font-bold text-lg">{data.TotaInstallmentsReceived || 0}</span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                                <i className="pi pi-list" />
                            </span>
                        </div>
                    </Card>

                    <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
                        <div className="flex-consulta justify-content-between gap-5">
                            <div className="flex-consulta flex-column gap-1">
                                <span style={{ color: 'white' }} className="text-sm">Valor total</span>
                                <span style={{ color: 'white' }} className="font-bold text-lg">
                                    {data.SocialAssistances?.reduce((sum: number, a: any) => sum + (a.TotalAssistanceAmount || 0), 0)
                                        ? formatCurrency(data.SocialAssistances.reduce((sum: number, a: any) => sum + (a.TotalAssistanceAmount || 0), 0))
                                        : 'R$ 0,00'}
                                </span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                                <i className="pi pi-dollar" />
                            </span>
                        </div>
                    </Card>


                </div>
                <br></br>
                <br></br>
                {data.AssistancesIncomeHistory && (
                    <>
                        <h3 style={{ color: '#1e3a8a', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
                            Histórico de Renda de Assistência
                        </h3>
                        <div className="flex-consulta flex-wrap gap-3">
                            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8', minWidth: '140px' }}>
                                <div className="flex-consulta justify-content-between gap-5">
                                    <div className="flex-consulta flex-column gap-1">
                                        <span style={{ color: 'white' }} className="text-sm">Último Mês</span>
                                        <span style={{ color: 'white' }} className="font-bold text-lg">{formatCurrency(data.AssistancesIncomeHistory.LastMonth)}</span>
                                    </div>
                                </div>
                            </Card>
                            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8', minWidth: '140px' }}>
                                <div className="flex-consulta justify-content-between gap-5">
                                    <div className="flex-consulta flex-column gap-1">
                                        <span style={{ color: 'white' }} className="text-sm">3 Meses</span>
                                        <span style={{ color: 'white' }} className="font-bold text-lg">{formatCurrency(data.AssistancesIncomeHistory.Last3Months)}</span>
                                    </div>
                                </div>
                            </Card>
                            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8', minWidth: '140px' }}>
                                <div className="flex-consulta justify-content-between gap-5">
                                    <div className="flex-consulta flex-column gap-1">
                                        <span style={{ color: 'white' }} className="text-sm">6 Meses</span>
                                        <span style={{ color: 'white' }} className="font-bold text-lg">{formatCurrency(data.AssistancesIncomeHistory.Last6Months)}</span>
                                    </div>
                                </div>
                            </Card>
                            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8', minWidth: '140px' }}>
                                <div className="flex-consulta justify-content-between gap-5">
                                    <div className="flex-consulta flex-column gap-1">
                                        <span style={{ color: 'white' }} className="text-sm">12 Meses</span>
                                        <span style={{ color: 'white' }} className="font-bold text-lg">{formatCurrency(data.AssistancesIncomeHistory.Last12Months)}</span>
                                    </div>
                                </div>
                            </Card>
                            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8', minWidth: '140px' }}>
                                <div className="flex-consulta justify-content-between gap-5">
                                    <div className="flex-consulta flex-column gap-1">
                                        <span style={{ color: 'white' }} className="text-sm">3 Anos</span>
                                        <span style={{ color: 'white' }} className="font-bold text-lg">{formatCurrency(data.AssistancesIncomeHistory.Last3Years)}</span>
                                    </div>
                                </div>
                            </Card>
                            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8', minWidth: '140px' }}>
                                <div className="flex-consulta justify-content-between gap-5">
                                    <div className="flex-consulta flex-column gap-1">
                                        <span style={{ color: 'white' }} className="text-sm">5 Anos</span>
                                        <span style={{ color: 'white' }} className="font-bold text-lg">{formatCurrency(data.AssistancesIncomeHistory.Last5Years)}</span>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </>
                )}
                <br></br>
                <br></br>

                {data.SocialAssistances && data.SocialAssistances.length > 0 && (
                    <>
                        <h3 style={{ color: '#1e3a8a', fontWeight: 600, marginTop: '1.5rem', marginBottom: '1rem' }}>
                            Assistências Sociais:
                        </h3>

                        <DataTable
                            size="small"
                            value={data.SocialAssistances}
                            tableStyle={{ minWidth: '50rem' }}
                        >
                            <Column
                                field="ProgramName"
                                header="Benefício"
                                body={(rowData) => rowData.ProgramName || 'Não Informado'}
                            />
                            <Column
                                field="FirstAssistanceStartDate"
                                header="Data Início"
                                body={(rowData) => formatDate(rowData.FirstAssistanceStartDate)}
                            />
                            <Column
                                field="LastAssistanceEndDate"
                                header="Data Fim"
                                body={(rowData) => formatDate(rowData.LastAssistanceEndDate)}
                            />
                            <Column
                                field="AvgAssistanceAmount"
                                header="Valor"
                                body={(rowData) => formatCurrency(rowData.AvgAssistanceAmount)}
                            />
                            <Column
                                field="TotalAssistanceAmount"
                                header="Valor Total"
                                body={(rowData) => formatCurrency(rowData.TotalAssistanceAmount)}
                            />
                            <Column
                                field="TotalInstallments"
                                header="Total Parcelas"
                                body={(rowData) => rowData.TotalInstallments || 0}
                            />
                        </DataTable>
                    </>
                )}
            </div>
        </Panel>
    );
}
